export const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const radLat1 = (Math.PI * lat1) / 180
  const radLat2 = (Math.PI * lat2) / 180
  const theta = lng1 - lng2
  const radTheta = (Math.PI * theta) / 180
  let distance =
    Math.sin(radLat1) * Math.sin(radLat2) +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta)
  distance = Math.acos(distance)
  distance = (distance * 180) / Math.PI
  distance = distance * 60 * 1.1515
  distance = +(distance * 1.609344).toFixed(1)

  // Return the distance in kilometers rounded to 1 decimal place
  return distance.toFixed(1)
}
